import React from 'react';

/**
 * 상품 상세 컴포넌트 속성 정의
 * 에디터의 속성 패널에서 사용할 속성 그룹 및 컨트롤 정의
 */
const ProductDetailProperties = [
  {
    group: '기본 설정',
    properties: [
      {
        name: 'componentProps.productId',
        label: '상품 ID',
        control: 'TextField',
        type: 'number',
        defaultValue: 0,
        helpText: '상품 ID를 입력하세요. 페이지 URL의 상품 ID를 우선합니다.'
      }
    ]
  },
  {
    group: '레이아웃 설정',
    properties: [
      {
        name: 'componentProps.order',
        label: '정렬 순서',
        control: 'Select',
        options: [
          { label: '기본', value: '' },
          { label: '역순', value: 'order-last' }
        ],
        defaultValue: ''
      },
      {
        name: 'componentProps.none',
        label: '사이드바 표시',
        control: 'Select',
        options: [
          { label: '표시 안함', value: 'none' },
          { label: '표시', value: 'block' }
        ],
        defaultValue: 'none'
      },
      {
        name: 'componentProps.lg',
        label: '메인 컨텐츠 너비',
        control: 'Select',
        options: [
          { label: '전체 폭', value: '12' },
          { label: '75% 폭', value: '9' },
          { label: '66% 폭', value: '8' },
          { label: '50% 폭', value: '6' }
        ],
        defaultValue: '9'
      }
    ]
  },
  {
    group: '탭 설정',
    properties: [
      {
        name: 'componentProps.showDescriptionTab',
        label: '상품 설명 탭 표시',
        control: 'Checkbox',
        defaultValue: true
      },
      {
        name: 'componentProps.showReviewsTab',
        label: '리뷰 탭 표시',
        control: 'Checkbox',
        defaultValue: true
      },
      {
        name: 'componentProps.showSpecificationTab',
        label: '상품 스펙 탭 표시',
        control: 'Checkbox',
        defaultValue: true
      }
    ]
  },
  {
    group: '기타 설정',
    properties: [
      {
        name: 'componentProps.showStock',
        label: '재고 표시',
        control: 'Checkbox',
        defaultValue: false
      }
    ]
  },
  {
    group: '스타일 설정',
    properties: [
      {
        name: 'style.padding',
        label: '여백',
        control: 'TextField',
        defaultValue: '20px'
      },
      {
        name: 'style.backgroundColor',
        label: '배경색',
        control: 'ColorPicker',
        defaultValue: '#ffffff'
      },
      {
        name: 'style.borderRadius',
        label: '모서리 둥글기',
        control: 'TextField',
        defaultValue: '0px'
      },
      {
        name: 'style.border',
        label: '테두리',
        control: 'TextField',
        defaultValue: '1px solid #eeeeee'
      },
      {
        name: 'style.boxShadow',
        label: '그림자',
        control: 'TextField',
        defaultValue: 'none'
      }
    ]
  }
];

export default ProductDetailProperties; 